import { useEffect, useState } from 'react';
import axios from 'axios';
import { ScrollArea } from '@radix-ui/react-scroll-area';
import Loader from './Loader';

export default function PDFPreview({ url }: { url: string }) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [pdfBlobUrl, setPdfBlobUrl] = useState<string>('');

  const downloadPdf = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(url, {
        responseType: 'blob',
      });

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);
      setPdfBlobUrl(blobUrl);
    } catch (error) {
      console.error('Error downloading PDF:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (url) {
      downloadPdf();
    }
  }, [url]);

  if (isLoading) return <Loader />;

  return (
    <ScrollArea className='h-[600px] w-full px-8'>
      <iframe title='PDF Preview' className='w-full h-full' src={pdfBlobUrl}>
        This browser does not support PDFs. Please download the PDF to view it.
      </iframe>
    </ScrollArea>
  );
}
